import { ECurrencyType, getPairCoinTypes, ICurrencyDto, TPriceRespApiDto } from '../../coins'
import { defaultSelectedCoinsState, TCoinWidgetState } from '../stateManagement'

const mapPairPriceToWidgetStateState = (
    initSelectedCoinPrices: TPriceRespApiDto,
    availableCurrencies: ICurrencyDto[],
): TCoinWidgetState => {
    const {
        pair,
        amount_quote,
        amount_base,
        min_amount_base,
        max_amount_base,
        min_amount_quote,
        max_amount_quote,
    } = initSelectedCoinPrices

    const fromCode = pair?.quote
    const toCode = pair?.base

    const { fromCurrencyType, toCurrencyType } = getPairCoinTypes({
        availableCurrencies,
        fromCode,
        toCode,
    })

    return {
        ...defaultSelectedCoinsState,
        from: {
            code: pair?.quote,
            isCrypto: fromCurrencyType === ECurrencyType.CRYPTO,
            amount: amount_quote,
            minAmount: min_amount_quote,
            maxAmount: max_amount_quote,
            isLoading: false,
        },
        to: {
            code: pair?.base,
            isCrypto: toCurrencyType === ECurrencyType.CRYPTO,
            amount: amount_base,
            minAmount: min_amount_base,
            maxAmount: max_amount_base,
            isLoading: false,
        },
    }
}

export { mapPairPriceToWidgetStateState }
